import { render, staticRenderFns } from "./BrFooter.vue?vue&type=template&id=0cb8b770&"
import script from "./BrFooter.vue?vue&type=script&lang=js&"
export * from "./BrFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports